import { ClickAwayListener, Tooltip, Typography } from '@mui/material';
import { Info } from 'lucide-react';
import React, { useState } from 'react';

interface FieldLabelProps {
  label: string;
  description?: string;
  required?: boolean;
  htmlFor?: string;
}

/** Field label with an info icon; the description shows on hover (desktop) or click (touch). */
export const FieldLabel: React.FC<FieldLabelProps> = ({
  label,
  description,
  required,
  htmlFor,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-1 flex items-center gap-1">
      <Typography
        component="label"
        htmlFor={htmlFor}
        variant="body2"
        className="font-medium text-gray-700 dark:text-slate-200"
      >
        {label}
        {required ? ' *' : ''}
      </Typography>
      {description && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Tooltip
            title={description}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            disableFocusListener
            disableTouchListener
            arrow
            placement="top"
          >
            <button
              type="button"
              aria-label={description}
              onClick={() => setOpen((current) => !current)}
              className="inline-flex text-gray-400 hover:text-gray-600 dark:text-slate-500 dark:hover:text-slate-300"
            >
              <Info size={14} />
            </button>
          </Tooltip>
        </ClickAwayListener>
      )}
    </div>
  );
};
